<style>
  .clearfix:after {
    content: '';
    display: block;
    visibility: hidden;
    clear: both;
  }
  .select-container {
    padding: 15px 2% 3px;
  }
  .select-left {
    float: left;
    display: table;
  }
  .select-left > div {
    vertical-align: top;
  }
  .select-left > div:not(:last-child) {
    margin-right: 5px;
  }
  .select-right {
    float: right;
  }
</style>

<template>
  <div>
    <div class="select-container clearfix" style="margin-top: 2%;margin-left: 2%;float: left;">
    <span style="font-size:30px;font-weight:bold;">安全基线检查修复</span><br><br><br>
    <p>  <strong><span style="color: rgb(250, 84, 28)">同学您好，您的PC终端安全不合规</span></strong>。请您根据拦截提示页面选择对应安全合规软件进行修复。</p>
    <br>
    <h1 style="font-size:28px;font-weight:bold;">一、终端安全软件下载安装</h1><br>
    <h2 style="font-size:26px;font-weight:bold;">1、<strong>美团安全管理客户端（MOA）</strong>下载安装</h2>
    <p><strong><span style="color: rgb(255, 77, 79)">解决方法</span>：请确认您的操作系统后下载对应安装包。</strong></p>
    <div style="background:#CCFFFF;width:100%;height:100px"><p>Mac：<a style="color:#1890ff" data-auto_update="0" href="https://s3plus.sankuai.com/v1/mss_4964a1f571bb46daa9dbb9a0821e2f58/itmenhu/%E5%8A%9E%E5%85%AC%E8%BD%AF%E4%BB%B6/%E4%BC%81%E4%B8%9A%E5%86%85%E9%83%A8%E8%BD%AF%E4%BB%B6/MOA/mac-for-1.3.1.0-release.pkg" target="_blank" rel="noopener">Mac下MOA下载</a> 。<strong>注意：MAC 上MOA最新版本：【1.3.1.0 】（要求macOS操作系统版本&gt;=10.11）</strong></p>
    <p><span style="color:red">MAC操作系统10.11以下版本存有多个安全漏洞，需要升级到10.11后才能修复，所以MOA、SEP、DLP最新版本对于10.10及以下操作系统不再提供兼容，必需要升级操作系统。升级MAC操作系统请联系6000帮助台协助。</span></p>
    </div>
    <div style="background:#CCFFFF;width:100%;height:30px"><p>Windows: <a style="color:#1890ff" data-auto_update="0" href="https://s3plus.sankuai.com/v1/mss_4964a1f571bb46daa9dbb9a0821e2f58/itmenhu/%E5%8A%9E%E5%85%AC%E8%BD%AF%E4%BB%B6/%E4%BC%81%E4%B8%9A%E5%86%85%E9%83%A8%E8%BD%AF%E4%BB%B6/MOA/MOA%20for%20Windows%201.3.0.0.exe" class="ct-link" target="_blank" rel="noopener">Win下MOA下载</a>。  <strong>注意：Windows上MOA最新版本：【1.3.0.0 】（要求Windows 7及以上版本）</strong></p></div>
    <p>安装遇到问题请在左侧菜单栏<span style="color:red">【常见问题FQA】</span>查看，若以上没有解决您的问题，请联系6000帮助台进行协助。<br></p>
    <div style="background:#EEF977;width:100%;height:30px"><p>拦截提示：<strong>「<span style="color:">当前计算机MOA未安装或不是最新版本，请点击「立即处理」</span></strong></p></div>
    <img src="../assets/baselineRepair/baselineRepair_pic01.png" width=540px height=360px ><br><br>
    <div style="background:#EEF977;width:100%;height:30px"><p>拦截提示：<strong>「<span style="color:">拦截提示：「终端安全不合规，请点击「立即处理」</span></strong></p></div>
    <img src="../assets/baselineRepair/baselineRepair_pic08.png" width=540px height=660px ><br><br>
    <h2 style="font-size:26px;font-weight:bold;" id="id-2、赛门铁克杀毒软件（SEP）下载安装">2、<strong>赛门铁克杀毒软件（SEP）</strong>下载安装</h2>
    <p><strong><span style="color: rgb(255, 77, 79)">解决方法</span>：请确认您的操作系统后下载对应安装包。</strong></p>
    <div style="background:#CCFFFF;width:100%;height:30px"><p>Mac：<a style="color:#1890ff" data-auto_update="0" href="https://s3plus.sankuai.com/v1/mss_4964a1f571bb46daa9dbb9a0821e2f58/itmenhu/%E5%8A%9E%E5%85%AC%E8%BD%AF%E4%BB%B6/%E4%BC%81%E4%B8%9A%E5%86%85%E9%83%A8%E8%BD%AF%E4%BB%B6/SEP/14.2.2%20RU%202%20SEPRemote.pkg" class="ct-link" target="_blank" rel="noopener">Mac下SEP下载</a>。</p>
    </div>
    <div style="background:#CCFFFF;width:100%;height:30px"><p>Windows 32位操作系统: <a style="color:#1890ff" data-auto_update="0" href="https://s3plus.sankuai.com/v1/mss_4964a1f571bb46daa9dbb9a0821e2f58/itmenhu/%E5%8A%9E%E5%85%AC%E8%BD%AF%E4%BB%B6/%E4%BC%81%E4%B8%9A%E5%86%85%E9%83%A8%E8%BD%AF%E4%BB%B6/SEP/14.2.5323.2000_x86_setup.exe" class="ct-link" target="_blank" rel="noopener">Win下32位SEP下载</a>。Windows 64位操作系统: <a style="color:#1890ff" data-auto_update="0" href="https://s3plus.sankuai.com/v1/mss_4964a1f571bb46daa9dbb9a0821e2f58/itmenhu/%E5%8A%9E%E5%85%AC%E8%BD%AF%E4%BB%B6/%E4%BC%81%E4%B8%9A%E5%86%85%E9%83%A8%E8%BD%AF%E4%BB%B6/SEP/14.2.5323.2000_x64_setup.exe" class="ct-link" target="_blank" rel="noopener">Win下64位SEP下载</a>。</p></div>
    <br><br>
    <div style="background:#EEF977;width:100%;height:30px"><p>拦截提示：<strong>您已被限制访问办公系统，请及时安装杀毒软件</strong></p></div>
    <img src="../assets/baselineRepair/baselineRepair_pic07.png" width=100% height=500px ><br><br>
    <h2 style="font-size:26px;font-weight:bold;" id="id-3、数据防泄漏客户端（DLP）下载安装">3、<strong>数据防泄漏客户端（DLP）</strong>下载安装</h2>
    <p><strong><span style="color: rgb(255, 77, 79)">解决方法</span>：请确认您的操作系统后下载对应安装包。</strong></p>
    <div style="background:#CCFFFF;width:100%;height:30px"><p>Mac：<a style="color:#1890ff" data-auto_update="0" href="https://s3plus.sankuai.com/v1/mss_4964a1f571bb46daa9dbb9a0821e2f58/itmenhu/%E5%8A%9E%E5%85%AC%E8%BD%AF%E4%BB%B6/%E4%BC%81%E4%B8%9A%E5%86%85%E9%83%A8%E8%BD%AF%E4%BB%B6/DLP/mac%20new.zip" class="ct-link" target="_blank" rel="noopener">Mac下DLP下载</a>。</p></div>
    <div style="background:#CCFFFF;width:100%;height:30px"><p>Windows: <a style="color:#1890ff" data-auto_update="0" href="https://s3plus.sankuai.com/v1/mss_4964a1f571bb46daa9dbb9a0821e2f58/itmenhu/%E5%8A%9E%E5%85%AC%E8%BD%AF%E4%BB%B6/%E4%BC%81%E4%B8%9A%E5%86%85%E9%83%A8%E8%BD%AF%E4%BB%B6/DLP/DLP.exe" class="ct-link" target="_blank" rel="noopener">Win下DLP下载</a>。</p></div>
    <br><br>
    <div style="background:#EEF977;width:100%;height:30px"><p>拦截提示：<strong>您已被限制访问办公系统，请及时安装杀毒软件</strong></p></div>
    <img src="../assets/baselineRepair/baselineRepair_pic02.png" width=100% height=500px ><br><br>
    <h1 style="font-size:28px;font-weight:bold;">二、通过MOA排查“安全基线检查”结果。</h1><br>
    <h2 style="font-size:24px;font-weight:bold;">1、打开MOA客户端页面，查看“安全基线检查”检查结果。</h2>
    <p style="text-align: start;margin-left: 20px;">a、Windows系统打开MOA客户端方法：点击运行的MOA图标。</p>
    <img src="../assets/baselineRepair/baselineRepair_pic03.png" width=540px height=160px ><br>
    <p style="text-align: start;margin-left: 20px;">在跳出的MOA客户端界面上选择“安全基线检查”选项，查看安全基线检查结果。</p>
    <img src="../assets/baselineRepair/baselineRepair_pic04.png" width=640px height=440px ><br>
    <p style="text-align: start;margin-left: 20px;">b、Mac系统打开MOA客户端方法：点击运行的MOA图标。在跳出的MOA客户端界面上选择“安全基线检测”选项，查看安全基线检查结果。</p>
    <img src="../assets/baselineRepair/baselineRepair_pic05.png" width=940px height=600px ><br><br>
    <h2 style="font-size:24px;font-weight:bold;">2、排查“安全基线检测”。</h2>
    <img src="../assets/baselineRepair/baselineRepair_pic06.png" width=660px height=420px ><br>
    a、赛门铁克杀毒软件相关基线   显示红色
    <img src="../assets/terminalIllegal/terminalIllegal_pic05.png" width=40px height=30px >
    ，表示赛门铁克杀毒软件未安装或未正常运行，请进入
    <span style="color:#63B8FF;text-decoration:underline;cursor:pointer" @click="routerUrl('/saimenInstallForWin')">杀软安装指南—Windows</span>，
    <span style="color:#63B8FF;text-decoration:underline;cursor:pointer" @click="routerUrl('/saimenInstallForMac')">杀软安装指南--macOS</span>进行排查。<br>
    b、数据防泄漏客户端相关基线  显示红色
    <img src="../assets/terminalIllegal/terminalIllegal_pic05.png" width=40px height=30px >
    ，表示数据防泄漏客户端未安装、未注册、或未正常运行，请进入
    <span style="color:#63B8FF;text-decoration:underline;cursor:pointer" @click="routerUrl('/dataLeakInstallForWin')">DLP安装指南--Windows</span>，
    <span style="color:#63B8FF;text-decoration:underline;cursor:pointer" @click="routerUrl('/dataLeakInstallForMac')">DLP安装指南--macOS</span>进行排查。<br><br>
    <h1 style="font-size:24px;font-weight:bold;">3、以上提示的红色<img src="../assets/terminalIllegal/terminalIllegal_pic05.png" width=40px height=30px >修复完成后，请重新登录应用系统，如还有问题，请大象联系6000协助</h1>
    <p style="text-align: start;">a、如遇特殊情紧急情况，员工可申请临时白名单，请从此进入<span style="color:#63B8FF;text-decoration:underline;cursor:pointer" @click="routerUrl('/whiteApply')">临时白名单</span>。</p>
    </div>
  </div>
</template>

<script>
  import store from '../vuex/service/store'
  import axios from 'axios'
  import {mapState} from 'vuex';
  import util from '../views/util/commonUtil'

  export default {
    store: store,
    mounted: function () {
      var vm =this;
      if(vm.token == ""){
        var token = this.getCookie("access-token");
        if(token != null){
          vm.$store.commit('UPDATETOKEN',token);
          vm.token = token;
        }
      }
      vm.getUser();
    },
    computed: mapState({
      loginRediret: function (state) {
        return state.loginRediret;
      },
      cookieName: function (state) {
        return state.cookieName;
      },
      getuserAPI: function (state) {
        return state.getuserAPI;
      }
    }),
    filters: {
      idcExplain(val) {
        return util.idcExplain(val)
      },
      timeFormat(val) {
        return util.timeFormat(val)
      },
      switchColor(val) {
        return util.switchColor(val)
      },
      statusExplain(val) {
        return util.statusExplain(val)
      }
    },
    methods: {
      reset() {
        var vm = this;
        vm.name = '';
        vm.rasp = '';
        vm.proc = '';
        vm.ws = '';
        vm.query_arg = 'hostname';
        vm.query_value = '';
      },
      masterStatusColor(status) {
        if (status == 1) {
          return "#A1D6E4"
        }
        if (status == 0) {
          return "#878D99"
        }
        if (status == 4) {
          return "#878D99"
        }
        if (status == 6) {
          return "#F5A9A9"
        }
        if (status == 5) {
          return "#FFC78E"
        }
      },
      kmUrl(URL){
        window.open(URL);
      },
      routerUrl(URL){
        this.$router.push(URL)
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      getCookie(name){
        var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
        if(arr=document.cookie.match(reg))
          return unescape(arr[2]);
        else
          return null;
      },
      getUser() {
        var vm = this;
        if (vm.user == null || vm.user == "") {
          vm.user = vm.getCookie("username");
          document.cookie="ssoid="+vm.getCookie("access-token");
          axios.get(vm.getuserAPI, {
            withCredentials: true
          }).then((response) => {
            if(response.data.status==401){
               document.cookie = vm.cookieName + vm.$route.fullPath;
               window.location = vm.loginRediret;
            }

          }).catch(function (error) {
            vm.requesterrorinfo(error)
          })
        }
      },
      requesterrorinfo(error){
        var vm =this;
        if (error.response) {
          var code = error.response.status;
          if (code == 401) {
            vm.$message.error("401:您未登录");
            var count = vm.getCookie("access-count")
            window.location = vm.loginRediret;
            if(count==null || count==0){
              document.cookie="access-count=1";
              vm.$message('您未登录,请刷新');
              document.cookie = vm.cookieName + vm.$route.fullPath;
              window.location = vm.loginRediret;
            }else{
              vm.$message('您未登录,请刷新');
            }
          } else {
            if (code == 404) {
              vm.$notify({
                title: '提示',
                message: '404:Not found!',
                type: 'error'
              });
            } else {
              vm.$notify({
                title: '提示',
                message: '501:服务端未响应!',
                type: 'error'
              });
            }
          }
        } else {
          vm.$notify({
            title: '提示',
            message: '502:服务端未响应!',
            type: 'error'

          });
        }
      }
    },
    data() {
      return {
        hostname:'',
        token:''
      }
    }
  }
</script>
<style>
  .select1 {
    width: 100px;
  }
  .select2 {
    width: 130px;
  }
  .select3 {
    width: 160px;
  }
  .input1 {
    width: 350px;
  }
  .input2 {
    width: 210px;
  }
  .demo-table-expand label {
    width: 140px;
    color: #5d94bf;
  }
</style>



// WEBPACK FOOTER //
// baselineRepair.vue?2895b967